import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import trEN from "./locales/en/translation.json";
import trSE from "./locales/se/translation.json";

const resources = {
  en: { translation: trEN },
  se: { translation: trSE },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
